export const APPRENTICESHIP_REGULAR = 1
export const APPRENTICESHIP_DUAL = 2
export const APPRENTICESHIP_GRAD = 3
